import { ColDef } from 'ag-grid-community';
import { IAgent } from '../../types/agent';
import { ILeaveRequest } from '../../types/leave';
import { formatDate } from '../../utils';
import { Eye } from 'lucide-react';

interface UseLeaveRequestsColProps {
  onView: (data: ILeaveRequest) => void;
  agents: IAgent[];
}

export const useLeaveRequestsCol = ({
  onView,
  agents,
}: UseLeaveRequestsColProps): ColDef[] => {
  const getAgentName = (kimId: string) => {
    const agent = agents.find((a) => a.kimId === kimId);
    return agent?.name || kimId;
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'approved':
        return 'bg-green-100 text-green-800 border border-green-200';
      case 'rejected':
        return 'bg-red-100 text-red-800 border border-red-200';
      case 'request-for-info':
        return 'bg-yellow-100 text-yellow-800 border border-yellow-200';
      default:
        return 'bg-blue-100 text-blue-800 border border-blue-200';
    }
  };

  return [
    {
      headerName: 'Agent',
      field: 'kimId',
      cellRenderer: (params: any) => getAgentName(params.value),
      filter: 'agTextColumnFilter',
      minWidth: 150,
    },
    {
      headerName: 'Leave Type',
      field: 'type',
      cellRenderer: (params: any) => (
        <span className="capitalize">{params.value}</span>
      ),
      filter: 'agTextColumnFilter',
      minWidth: 120,
    },
    {
      headerName: 'Start Date',
      field: 'startTime',
      cellRenderer: (params: any) => formatDate(params.value),
      filter: 'agDateColumnFilter',
      minWidth: 130,
    },
    {
      headerName: 'End Date',
      field: 'stopTime',
      cellRenderer: (params: any) => formatDate(params.value),
      filter: 'agDateColumnFilter',
      minWidth: 130,
    },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: (params: any) => (
        <span
          className={`inline-block px-2 py-1 text-xs rounded ${getStatusColor(params.value)}`}
        >
          {params.value}
        </span>
      ),
      filter: 'agTextColumnFilter',
      minWidth: 140,
    },
    {
      headerName: 'Created',
      field: 'createdAt',
      cellRenderer: (params: any) => formatDate(params.value),
      filter: 'agDateColumnFilter',
      minWidth: 130,
    },
    {
      headerName: 'Actions',
      field: '_id',
      cellRenderer: (params: any) => (
        <button
          onClick={() => onView(params.data)}
          className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
        >
          <Eye size={16} />
          <span>View</span>
        </button>
      ),
      filter: false,
      sortable: false,
      minWidth: 100,
    },
  ];
};
